import is from 'typescript-styled-is'
import styled, { keyframes } from '../../../../theme'

export const showAnimation = keyframes`
  0% {
    opacity: 0;
    top: -50px
  }

  100% {
    opacity: 1;
    top: 0;
  }
`

const DatePickerContainer = styled.div<IDatePickerContainerProps>`
  width: 300px;
  user-select: none;
  top: -50px;
  opacity: 0;
  position: relative;
  pointer-events: auto;
  transition: width 0.8s cubic-bezier(1, -0.55, 0.2, 1.37);
  animation: ${showAnimation} 0.2s linear forwards;

  ${is('sized')`
    width: 180px;
  `}
`

export default DatePickerContainer

export interface IDatePickerContainerProps {
  sized?: boolean
}
